import React, { Fragment, useEffect, useState } from "react";
import axios from "axios";

function EquipoAmbulatorio(props) {
  const [list, setList] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://suadesarrollo.azurewebsites.net/api/ObtenerEquipoAmbulatorio",
    })
      .then((Response) => {
        setList(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList]);
  return (
    <Fragment>
      <div className="container">
        <div className="text-left">
          <div class="container-fluid">
            <div class="card shadow mb-4">
              <div class="card-header py-3">
                <h6 class="m-0 font-weight-bold text-primary">
                  Subtítulo: 1.2 Equipo de autoevaluación ambulatorios{" "}
                </h6>
                <div>
                  Relacione de acuerdo con el servicio solicitado los
                  representantes que conforman el equipo de autoevaluación y
                  mejoramiento ambulatorio; en caso de que cuente con otros
                  participantes relaciónelos
                </div>
              </div>
              <div class="card-body">
                <div class="table-responsive">
                  <table
                    class="table table-bordered"
                    id="dataTable"
                    width="100%"
                    cellspacing="0"
                  >
                    <thead>
                      <tr>
                        <th>Id</th>
                        <th>Nombre</th>
                        <th>Area que epresenta</th>
                        <th>Cargo</th>
                      </tr>
                    </thead>
                    <tbody>
                      {list.map((item) => {
                        return (
                          <tr>
                            <td>{item.id}</td>
                            <td>{item.nombre}</td>
                            <td>{item.area}</td>
                            <td>{item.cargo}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
                <h6 class="m-0 font-weight-bold text-primary">
                  Subtítulo: 1.2.1 Equipos primarios de mejoramiento de los
                  servicios de consulta externa
                </h6>
                <br></br>
                <left>
                  {" "}
                  <div>
                    Relacione los integrantes de los equipos que apoyan al
                    equipo de autoevaluación y mejoramiento ambulatorio en la
                    implementación, mantenimiento y mejoramiento de los
                    estándares de acreditación en los diferentes servicios
                    ambulatorios. En caso de contar con otros equipos de apoyo
                    relaciónelos con el nombre de sus integrantes, en tablas
                    adicionales que conserven la estructura.
                  </div>
                </left>
                <br></br>
                <input type="file" name="files" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}
export default EquipoAmbulatorio;
